import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastModule } from 'primeng/toast';
import { Observable } from 'rxjs';
import { ApprezzoCommonModule } from '../../../apprezzoo-common.module';
import { AuthService } from '../../../services/auth/auth.service';
import { PagesService } from '../../../services/pages/pages.service';
import { LoginSignupComponent } from '../../public/login-signup/login-signup.component';
import { CookieConsentComponent } from '../cookieconsent/cookie-consent.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    NgFor,
    TranslocoDirective,
    DialogModule,
    LoginSignupComponent,
    SkeletonModule,
    MenuModule,
    ToastModule,
    NgIf,
    ApprezzoCommonModule,
    CookieConsentComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  items$: Observable<MenuItem[]>;
  userMenuitems$: Observable<MenuItem[]>;
  productsCategories: any[] = [];
  platform: string;
  isLoggedIn$: Observable<boolean>;

  constructor(
    pagesService: PagesService,
    translocoService: TranslocoService,
    authService: AuthService,
  ) {
    this.items$ = pagesService.getPages();
    this.userMenuitems$ = pagesService.getUserMenu();
    this.platform = Capacitor.getPlatform();
    this.isLoggedIn$ = authService.isLoggedIn();
  }

  replaceText(text: string) {
    const oldText = text;
    const newText = oldText.split('-').join(' ');
    const upperText = newText.charAt(0).toUpperCase() + newText.slice(1);

    return upperText;
  }
}
